// import './lottie.scss'
// import bodymovin from "bodymovin";

import lottie from 'lottie-web';

function init() {
    // delete this
    console.log("hello lottie");
    //reivew usage of scrips for each animation
 

}
export default init

export function initLottie(container) {
    var animations = container.querySelectorAll(".lottie-item"), //.attr("data-lottie");
        i, 
        len = animations.length;


    for (i = 0; i < len; i += 1) {
        let anim;
        // var name = document.getElementById(animations[i])
        var animationName = animations[i].getAttribute("data-lottie-item");
        var animationId = animations[i].getAttribute("id");

        var elem = document.getElementById(animationId);
        var parentElem = elem.closest("li"); // div for css hover states etc

        // var elem = document.getElementById('lottie-container-' + animationName);
        // console.log("animationId", animationId);
        // console.log("elem", elem);
        // console.log("animationDataUrl", animationDataUrl);

        var animationDataUrl = elem.getAttribute("data-lottie");

        var animData = {
            container: elem,
            renderer: 'svg',
            loop: true,
            // autoplay: true,
            autoplay: false,
            rendererSettings: {
                progressiveLoad: true,
                preserveAspectRatio: 'xMidYMid meet'
            },
            path: animationDataUrl
        };
        anim = new lottie.loadAnimation(animData);
        anim.setSubframe(false);


        // console.log("set anination to pause");
        // anim.pause();
        anim.pause();
        //add hover event linsterne and attached play to it
        // if touch device - just play on load

        // to do - set this mouseenter and mouseleave on the same dom component that uses the hover to move the lines (its not atm)

        // detect if we on touch devices
        if (document.body.classList.contains('is-touch')){
            // console.log("is touch so start animations")
            // parentElem.addEventListener('mouseenter', function () {
            //     // revie this - i.e need solution for touch devices (just hae it playing already1?)
            //     console.log("mouseenter", parentElem, anim);
    
            //     if (anim.isPaused) {
                    anim.play();
            //         console.log("Animation played");
            //     }
            //     // else {
            //     //     anim.pause();
            //     //     console.log("Animation paused");
            //     // }
    
            // })
            // parentElem.addEventListener('mouseleave', function () {
            //     // revie this - i.e need solution for touch devices (just hae it playing already1?)
            //     console.log("mouseleave", parentElem, anim);
            //     anim.pause();
    
            //     // if (anim.isPlaying) {
            //     //     anim.pause();
            //     //     console.log("Animation paused");
            //     // }
            //     // } else {
            //     //     anim.pause();
            //     //     console.log("Animation paused");
            //     // }
    
            // });;

        } else {


            // console.log("is mouse so keep sam uix behaviour");


            parentElem.addEventListener('mouseenter', function () {
                // revie this - i.e need solution for touch devices (just hae it playing already1?)
                // console.log("mouseenter", parentElem, anim);
    
                if (anim.isPaused) {
                    anim.play();
                    // console.log("Animation played");
                }
                // else {
                //     anim.pause();
                //     console.log("Animation paused");
                // }
    
            })
            parentElem.addEventListener('mouseleave', function () {
                // revie this - i.e need solution for touch devices (just hae it playing already1?)
                // console.log("mouseleave", parentElem, anim);
                anim.pause();
    
                // if (anim.isPlaying) {
                //     anim.pause();
                //     console.log("Animation paused");
                // }
                // } else {
                //     anim.pause();
                //     console.log("Animation paused");
                // }
    
            });

        }

      

    }



    // ensure only plays when hover - i.e pause on load

    // add the css grid lines bg animasatins
    appendGridLines(container);

}


export function appendGridLines(container) {
    const numGridLines = 20; // Change this to the number of grid lines you want to add - based on css animations and paramaters
    const panelContainers = container.querySelectorAll('.nav-link__lottie'); // this selector changes depending on the instance of use ;
    // see if just using this target owporks other wise consier apparoch based ont he containtvariabel pulled in.

    panelContainers.forEach(panelContainer => {
        const lineGrids = panelContainer.querySelectorAll('.line-grid');

        lineGrids.forEach(lineGrid => {
            for (let i = 0; i < numGridLines; i++) {
                const gridLine = document.createElement('div');
                gridLine.classList.add('grid-line');
                lineGrid.appendChild(gridLine);
            }
        });
    });
}